import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { forYouItems } from '../../data/content';
export function ForYou() {
  return <Section data-id="element-139" data-mp="2obpndxsfbf6v">
      <SectionTitle subtitle="This system was created for you if…" data-id="element-140" data-mp="2oc7r1fhf0vot">
        Is Master Welding System™ for you?
      </SectionTitle>

      <ul className="mx-auto mt-8 grid w-full max-w-3xl gap-3 sm:grid-cols-2" data-id="element-141" data-mp="2t7dckd6wo8cd">
        {forYouItems.map(item => <li key={item} className="flex gap-3 rounded-xl border border-white/10 bg-ink-800 p-4" data-id="element-142" data-mp="3l0nixi7zzh53">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal" data-id="element-143" data-mp="370coy6be5mfp">
              <CheckIcon className="h-3.5 w-3.5 text-ink" aria-hidden="true" data-id="element-144" data-mp="3bynyefxrxuxe" />
            </span>
            <span className="text-[15px] leading-snug text-white/80" data-id="element-145" data-mp="1vke9nkpme461">{item}</span>
          </li>)}
      </ul>

      <p className="mx-auto mt-6 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-teal-bright" data-id="element-146" data-mp="20iz9hj0ymlty">
        If you recognized yourself in any of these, you’re exactly who we created
        this for.
      </p>

      <CtaBlock className="mt-8" headline="This was built for welders exactly like you" data-id="element-147" data-mp="32c5hg345ffa" />
    </Section>;
}